import { useEffect } from "react";
import { TextPage, TextSection } from "@/components/TextPage";

export default function AboutPage() {
  useEffect(() => {
    document.title = "About — Findora";
  }, []);

  return (
    <TextPage testId="about-page" eyebrow="About">
      <TextSection testId="about-body">
        <p>
          This is Findora | Stylely by Daden, where I bring you practical
          finds that transforms your home or personal use — without the
          marketing fluff. Every product is reviewed based on every verified
          buyer comment, complaint and return reasons. If a product doesn't
          hold up to that, I will not recommend it.
        </p>
      </TextSection>
    </TextPage>
  );
}
